import PropTypes from 'prop-types';
import React from 'react';

import propTypeBlockStyling from 'styling/config/editorBlock/PropTypes/blockStyling';

import TextStaticRichText from '../../domains/richText/components/TextStaticRichText';

const StaticText = ({ block: { content }, questionNumber, styling }) => (
  <TextStaticRichText
    content={content}
    questionNumber={questionNumber}
    styling={styling}
  />
);

StaticText.propTypes = {
  questionNumber: PropTypes.number,
  block: PropTypes.shape({
    content: PropTypes.object,
  }).isRequired,
  styling: propTypeBlockStyling,
};

export default StaticText;
